import React from 'react';
import PropTypes from 'prop-types';
import DatasetListItem from './DatasetListItem';

function DatasetList({
  datasets,
  onDatasetLoadClick,
  onFavoriteClick,
}) {
  return datasets.map((dataset) => (
    <DatasetListItem
      dataset={dataset}
      key={dataset.uuid}
      onDatasetLoadClick={onDatasetLoadClick}
      onFavoriteClick={onFavoriteClick}
    />
  ));
}

DatasetList.propTypes = {
  datasets: PropTypes.array.isRequired,
  onDatasetLoadClick: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
};

export default DatasetList;